import axios from "axios";

export default axios.create({
  baseURL: "https://covidcare.channelier.com/api",
  headers: {
    "Content-type": "application/json"
  }
});
